import { render, staticRenderFns } from "./Preliminary.vue?vue&type=template&id=5fa878ac&scoped=true&"
import script from "./Preliminary.vue?vue&type=script&lang=js&"
export * from "./Preliminary.vue?vue&type=script&lang=js&"
import style0 from "./Preliminary.vue?vue&type=style&index=0&id=5fa878ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa878ac",
  null
  
)

export default component.exports